import { render, staticRenderFns } from "./WideProject.vue?vue&type=template&id=c06e6a16&scoped=true&"
import script from "./WideProject.vue?vue&type=script&lang=js&"
export * from "./WideProject.vue?vue&type=script&lang=js&"
import style0 from "./WideProject.vue?vue&type=style&index=0&id=c06e6a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e6a16",
  null
  
)

export default component.exports